import { render, staticRenderFns } from "./EditPageInfo.vue?vue&type=template&id=3f336b54&"
import script from "./EditPageInfo.vue?vue&type=script&lang=js&"
export * from "./EditPageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f336b54')) {
      api.createRecord('3f336b54', component.options)
    } else {
      api.reload('3f336b54', component.options)
    }
    module.hot.accept("./EditPageInfo.vue?vue&type=template&id=3f336b54&", function () {
      api.rerender('3f336b54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/SiteBuilder/components/EditPageInfo.vue"
export default component.exports